<template>
	<el-main class="case">
		<ContentNav :bannerTextIMG="require('../../assets/case/bannerText.png')" :bannerimgIMG="require('../../assets/case/banner.png')"></ContentNav>
		<div class="content">
			<div class="container">
				<div class="case-details">
					<div class="title">{{caseDetail.title}}</div>
					<el-divider></el-divider>
					<div class="infor">
						<div class="time">
							<i class="el-icon-time"></i>
							<span>{{caseDetail.publishTime}}</span>
						</div>
						<div class="minus">
							<i class="el-icon-view"></i>
							<span>{{caseDetail.hits}}</span>
						</div>
						
					</div>
					<div class="text" v-html="caseDetail.contents"></div>
					<div class="last_next">
						<div class="item" @click="toDetails(prve.id)">
							<i class="el-icon-back"></i>
							<span>上一篇：{{prve.title}}</span>
						</div>
						<div class="item" @click="toDetails(next.id)">
							<span>下一篇：{{next.title}}</span>
							<i class="el-icon-right"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
    <Icongroup></Icongroup>

	</el-main>
</template>

<script>
	import ContentNav from '../../components/ContentNav'
	import Icongroup from "../../components/Icon_group";

	export default {
		components: {
			ContentNav,
			Icongroup
		},
		props: ["id", "caseType"],
		metaInfo() {
			return {
				title: `${(this.caseDetail.title ?? '') + '-'}${this.SystemOption.seoTitle ?? ''}`,
				meta: [{ // set meta
					name: 'keywords',
					content: this.caseDetail.keyWord ?? ''
				}, { // set meta
					name: 'description',
					content: this.caseDetail.describe ?? ''
				}]
			}
		},
		created() {
			this.loadSeo();
			this.getDetails();
			this.getPrveNext();
		},
		data() {
			return {
				MenuList: [{
					id: 0,
					name: "全部"
				}],
				caseDetail: {},
				CurrentType: 0, //当前选择类别
				OrderIcons: [{
						val: true,
						ClassName: 'el-icon-bottom'
					},
					{
						val: false,
						ClassName: 'el-icon-top'
					},
				],
				ArtickeyWord: '',
				SystemOption: [], //SEO 配置
				prve: {
					id: 0,
					title: ''
				},
				next: {
					id: 0,
					title: ''
				}
			}
		},
		computed: {
			//监听菜单栏变化
			getStoreMenuListChecked() {
				return this.$store.state.MenuListChecked;
			}
		},
		methods: {
			//查看详情
			getDetails() {
				let that = this;
				let id = that.id;
				this.axios({
					type: "get",
					url: this.Url.apiUrl + "Case/CaseDetails",
					params: {
						id: id
					}
				}).then((res) => {
					this.caseDetail = res.data;
				});
			},
			loadSeo() {
				//获取SEO配置
				this.axios.get(this.Url.apiUrl + "SystemOption/GetSystemOption").then(res => this.SystemOption = res.data);
			},
			//加载上下篇
			getPrveNext() {
				// alert(this.$store.state.caseOrder)
				this.getDetails();
				let that = this;
				let type = that.caseType;
				let id = that.id;
				let order = !this.$store.state.caseOrder;
				that.axios({
						type: "get",
						url: this.Url.apiUrl + "Case/GetCasePreOrNext",
						params: {
							id: id,
							type: type,
							isDesc: order,
						},
					})
					.then((res) => {
						console.log(res.data);
						that.prve.id = res.data.preID;
						that.prve.title = res.data.preTitle;
						that.next.id = res.data.nextID;
						that.next.title = res.data.nextTitle;
						// that.articleDeatl = res.data;
					});
			},
			toDetails(id) {
				let that = this;
				that.id = id;
				this.$router.push({
					name: "Casedetail",
					params: {
						id: that.id,
						caseType:that.caseType
					},
				});
				that.getDetails();
				that.getPrveNext();
			},
		},
		mounted() {
			//初始化路径数据
			this.$store.state.Currentposition = [{
				path: '/',
				name: '首页'
			}, {
				path: '/case.html',
				name: '经典案例'
			}]
			//获取专业领域
			this.axios({
				type: "get",
				url: this.Url.apiUrl + "ProfessionalField/GetProfessionalField",
			}).then((res) => {
				let data = new Array();
				data.push({
					id: 0,
					name: "全部",
					value: '',
					route: {
						path: "/case.html"
					}
				});
				let len = res.data.length;
				for (let i = 0; i < len; i++) {
					data.push({
						id: res.data[i].id,
						name: res.data[i].name,
						value: res.data[i].pinYinName,
						route: {
							name: 'case',
							params: {
								'caseType': res.data[i].pinYinName
							}
						}
					});
				}
				this.MenuList = data;
			});
		}

	}
</script>

<style lang="scss" scoped>
	.content {
		position: relative;
		width: 100%;

		.container {
			position: relative;
			width: 1200px;
			display: flex;
			margin: 0 auto;
			padding: 40px 0 120px 0;
			justify-content: space-between;

			@media screen and (max-width: 768px) {
				width: 100%;
				display: block;
				padding: 26px 21px;
				overflow: hidden;
			}

			.menu {
				@media screen and (max-width: 768px) {
					display: none;
				}
			}

			.contaniner-content {
				position: relative;
				flex: 0 0 950px;

				.select {
					width: 100%;
					display: flex;
					justify-content: space-between;
					align-items: center;

					.TimeOrder {
						flex: 0 0 150px;
						display: flex;
						color: #202020;
						align-items: center;

						@media screen and (max-width: 768px) {
							display: none;
						}

						i {
							flex: 0 0 8px;
							height: 17px;
							margin: 0 10px;
							font-size: 18px;
							cursor: pointer;
						}
					}

					.InputBox {
						@media screen and (max-width: 768px) {
							width: 100%;

							input {
								width: 100%;
							}
						}
					}
				}

				.itemList {
					position: relative;
					display: block;
					width: 100%;
					margin: 20px 0 0 0;

					.itemList-box {
						border-bottom: 1px solid #d8d8d8;
						height: auto;
						padding: 5px 0;
						margin: 5px 0;

						.title {
							color: #202020;
							font-weight: 600;
							line-height: 36px;
							cursor: pointer;
						}

						.text {
							font-size: 14px;
							color: #908c86;
							line-height: 23px;
						}
					}
				}

				.Pages {
					width: 100%;
					height: 100px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}

			.case-details {
				position: relative;
				flex: 0 0 1200px;

				.title {
					font-size: 16px;
					font-weight: 600;
					color: #4b4b4b;
					text-align: center;
				}

				.infor {
					font-size: 12px;
					color: #787878;
					display: flex;
					justify-content: center;

					@media screen and (max-width: 768px) {
						justify-content: space-around;
						align-items: center;
					}

					>div {
						margin-right: 66px;

						@media screen and (max-width: 768px) {
							margin-right: 0;
						}

						i {
							margin-right: 15px;

							@media screen and (max-width: 768px) {
								margin-right: 5px;
							}
						}
					}
				}

				.text {
					font-size: 12px;
					color: #787878;
					margin-top: 18px;
					line-height: 20px;
					max-width: 100%;

					img {
						margin: 20px auto;

						@media screen and (max-width: 768px) {
							width: 100%;
						}
					}
				}

				.last_next {
					position: relative;
					display: flex;
					height: 80px;

					.item {
						flex: 0 0 50%;
						background-color: rgba(240, 240, 240, 0.44);
						display: flex;
						align-items: center;
						justify-content: center;
						color: #797979;
						cursor: pointer;
						user-select: none;
						transition: 200ms;

						i {
							font-size: 20px;
							margin: 0 15px;
						}
					}

					.item:first-of-type {
						border-right: 1px solid rgba(240, 240, 240, 1);
					}

					.item:active {
						background-color: #d0a971;
						color: #fff;
					}
				}
			}
		}
	}
</style>
